export const UPDATE_USER = "UPDATE_USER";
export const SET_SELECTED_TENANT = "SET_SELECTED_TENANT";
